import { Link } from 'react-router-dom'
import { Clock, ArrowLeft } from 'lucide-react'
import { Card, CardContent } from '@/components/ui'

interface ComingSoonProps {
  featureName: string
}

export default function ComingSoon({ featureName }: ComingSoonProps) {
  return (
    <div className="mx-auto flex min-h-[60vh] w-full max-w-2xl items-center justify-center px-4 py-12">
      <Card className="w-full">
        <CardContent className="p-8 text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-700 dark:bg-primary-950/50 dark:text-primary-300">
            <Clock className="h-6 w-6" />
          </div>
          <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">
            {featureName} is coming soon
          </h1>
          <p className="mx-auto mt-3 max-w-md text-sm leading-6 text-gray-600 dark:text-gray-400">
            This area is temporarily unavailable while external integrations are completed.
            Core agency workflows remain available.
          </p>
          <Link
            to="/dashboard"
            className="mt-6 inline-flex items-center justify-center gap-2 rounded-lg bg-primary-600 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:ring-offset-gray-950"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Dashboard
          </Link>
        </CardContent>
      </Card>
    </div>
  )
}
